import appStore from 'store'
import api from './api'
import { QUERY_TYPE, PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: [],
    coinList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
    userDetailInfoVisible: false,
    userDetailInfo: [],
    userDetailInfoTotal: 0,
  },
  getters: {},
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice()
      state.totalCount = payload.totalCount
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setDetailList(state, payload) {
      state.detailList = payload.list ? payload.list.slice() : []
      state.detailTotalCount = payload.totalCount
    },
    setCoinList(state, payload) {
      state.coinList = payload || []
    },
    setUserDetailInfo(state, payload) {
      state.userDetailInfo = payload.list
      state.userDetailInfoTotal = payload.totalCount
    },
    setUserDetailInfoVisible(state, payload) {
      state.userDetailInfoVisible = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getUserList(query).then((res) => {
        console.log('res', res)
        if (res.code == 0) {
          commit('setUserList', res.data)
        }
      })
    },
    addRemark({ commit }, data) {
      return api.addRemark(data).then((res) => {
        return res
      })
    },
    getDetail({ commit }, data) {
      api.getDetail(data).then((res) => {
        if (res.code == 0) {
          commit('setDetailList', res.result)
        }
      })
    },
    getCoinList({ commit }, data) {
      api.getCoinList().then((res) => {
        if (res.code == 0) {
          commit('setCoinList', res.result)
        }
      })
    },
    exportExcel({ commit }, data) {
      return api.exportExcel(data).then((res) => {
        console.log('eeeeeeeeeee', res)
        return res
      })
    },

    getUserDetailInfo({ commit }, data) {
      api.getUserDetail(data).then((res) => {
        if (res.code == 0) {
          commit('setUserDetailInfo', res.data)
        }
      })
    },
  },
}

appStore.registerModule('contractassets', store)
